import { useTranslation } from '../../../i18n/useTranslation';

interface Props {
  open: boolean;
  count: number;
  onCancel: () => void;
  onConfirm: () => void;
  busy: boolean;
}

export function BookDeleteConfirmDialog({ open, count, onCancel, onConfirm, busy }: Props) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
      role="dialog" aria-modal="true" aria-labelledby="delete-dialog-title"
    >
      <div className="bg-white rounded shadow-lg p-5 max-w-md w-full">
        <h2 id="delete-dialog-title" className="text-lg font-semibold mb-3">
          {t('App.Admin.Books.BookDeleteConfirmDialog.Title', { count })}
        </h2>
        <p className="text-sm text-neutral-600 mb-4">
          {t('App.Admin.Books.BookDeleteConfirmDialog.Description')}
        </p>
        <div className="flex justify-end gap-2">
          <button
            type="button" onClick={onCancel}
            className="px-4 py-2 border rounded min-h-[44px]"
          >{t('App.Admin.Books.BookDeleteConfirmDialog.Cancel')}</button>
          <button
            type="button" onClick={onConfirm} disabled={busy}
            className="px-4 py-2 bg-red-600 text-white rounded disabled:opacity-50 min-h-[44px]"
          >
            {busy ? t('App.Admin.Books.BookDeleteConfirmDialog.Deleting') : t('App.Admin.Books.BookDeleteConfirmDialog.Delete')}
          </button>
        </div>
      </div>
    </div>
  );
}
